import { Navigate, useRoutes } from 'react-router-dom';
// auth
import AuthGuard from '../auth/AuthGuard';
import ClientGuestGuard from '../auth/ClientGuard';

// layouts
import CompactLayout from '../layouts/compact';
import DashboardLayout from '../layouts/dashboard';
// config
import { PATH_AFTER_CLIENT_LOGIN } from '../config-global';
// elements
import {
  ClientLoginPage,
  DashboardPage,
  Page404,
  ComingSoonPage,
  RequestListPage,
  RequestNewPage,
  RequestViewPage,
  UserAccountPage,
  RequestCompletedPage,
} from './elements';
import RoleBasedGuard from '../auth/RoleBasedGuard';

// ----------------------------------------------------------------------

export default function Router() {
  return useRoutes([
    // Client Login Routes
    {
      path: '/',
      element: (
        <ClientGuestGuard>
          <ClientLoginPage />
        </ClientGuestGuard>
      ),
    },

    // Client Dashboard Routes
    {
      path: 'cliente',
      element: (
        <AuthGuard type="client">
          <DashboardLayout />
        </AuthGuard>
      ),
      children: [
        { element: <Navigate to={PATH_AFTER_CLIENT_LOGIN} replace />, index: true },
        {
          path: 'app',
          element: (
            <RoleBasedGuard roles={['admin', 'user']} hasContent>
              <DashboardPage />
            </RoleBasedGuard>
          ),
        },
        {
          path: 'richieste',
          children: [
            {
              path: 'lista',
              element: (
                <RoleBasedGuard roles={['admin', 'user']} hasContent>
                  <RequestListPage />
                </RoleBasedGuard>
              ),
            },
            {
              path: 'nuova',
              element: (
                <RoleBasedGuard roles={['admin', 'user']} hasContent>
                  <RequestNewPage />
                </RoleBasedGuard>
              ),
            },
            {
              path: ':id',
              element: (
                <RoleBasedGuard roles={['admin', 'user']} hasContent>
                  <RequestViewPage />
                </RoleBasedGuard>
              ),
            },
          ],
        },
        {
          path: 'fatturazione',
          element: (
            <RoleBasedGuard roles={['admin', 'user']} hasContent>
              <RequestCompletedPage />
            </RoleBasedGuard>
          ),
        },
        { path: 'profilo', element: <UserAccountPage /> },
      ],
    },

    // Other Routes
    {
      element: <CompactLayout />,
      children: [
        { path: 'coming-soon', element: <ComingSoonPage /> },
        { path: '404', element: <Page404 /> },
      ],
    },
    // Catch-all Route
    { path: '*', element: <Navigate to="/404" replace /> },
  ]);
}
